/* Remove ':00:00' from date Oct 15th, 2023 Reverted */
/* Add using m_checkPage Apr 13, 2024 */
/* Add Meeting  May 1, 2026 */
<template lang="pug">
	div(id="kt-calendar")
		div(class='kt-calendar-header')
			b-dropdown(v-if="m_checkPage('Calendar')" size="sm" variant="outline-secondary")
				div(class="dropdown-header py-1")
					span Select Events to Display
				div(class="dropdown-item" v-for="ci in d_calItems" :key="ci.key" @click="m_toggleCalItem(ci)")
					span(:class="ci.key")
					span {{ci.lbl}}
					span
						fa-icon(:icon="ci.sel ? 'eye' : 'eye-slash'")
				template(v-slot:button-content)
					|  Options
			slot(name="team-member-filter" :fCU="true" :fTM="d_canVC")
		div(class="kt-calendar-content")
			div(class="header")
				div
					b-button(class="btn-prev" title="Previous Period" variant="none" @click="m_prev()")
						fa-icon(icon="angle-left") 
					b-button(class="btn-next" title="Next Period"  variant="none" @click="m_next()")
						fa-icon(icon="angle-right")
					b-form-select(v-if="d_cv=='w'" class="sel-weeks" v-model="d_period.wkSt" :options="c_selWeeks" plain )
					b-form-select(v-if="d_cv=='m'" class="sel-months" v-model="d_period.mnth" :options="c_selMonths" plain)
					b-form-select(class="sel-years" v-model="d_period.yr" :options="c_selYears" plain )
				div
					b-button(class="btn-curr" title="Go to Current Period" variant="link" v-show="!c_isCurr" @click="m_curr()") Go to Current {{d_cv=='w'? 'Week': d_cv=='m'? 'Month': ''}}
				div
					b-button(class="btn-add" variant="none" title="Add Activity"  @click="m_addTask()")
						fa-icon(icon="plus")
						| Activity
					b-button(class="btn-add" variant="none" title="Add Meeting"  @click="m_addMeeting()")
						fa-icon(icon="plus")
						| Meeting
					b-button(class="btn-wk" variant="none" title="Week View"  :pressed="d_cv =='w'"  @click="d_cv='w'") Week
					b-button(class="btn-mnth" variant="none" title="Month View"  :pressed="d_cv=='m'"  @click="d_cv='m'") Month
					b-button(class="btn-refresh" title="Refresh" variant="outline-secondary" @click="m_refresh")
						fa-icon(icon="sync")
			div(class="content")
				div(class="days")
					div(v-for="(d, ix) in d_days" :key="ix") {{d}}
				div(v-if="d_cv=='w'" class="days-week" )
					div(v-for="(day, ix) in d_daysInWeek" :key="ix" :class="day.class")
						span {{day.dtLcl}}
						div(class="events" v-if="day.events")
							div(v-for="e in day.events" :key="e.evid" :class="e.ci.key" v-if="e.ci.sel"
								v-b-popover="m_popOvr(e)" @click.stop="m_view(e, $event)" @touchstart="e.tch = true") {{e.lbl}}
						span(class="add" @click="m_addTask(day)")
						span(class="meeting" @click="m_addMeeting(day)")
				div(v-if="d_cv=='m'" class="week-month" v-for="(wk, wix) in d_weeksInMonth" :key="wix")
					div(v-for="(day, ix) in wk.days" :key="ix" :class="day.class") 
						span {{day.dom}}
						span(class="add" @click="m_addTask(day)")
						span(class="meeting" @click="m_addMeeting(day)")
						div(class="events" v-if="day.events")
							div(v-for="e in day.events" :key="e.evid" :class="e.ci.key" v-if="e.ci.sel"
								v-b-popover="m_popOvr(e)" @click.stop="m_view(e, $event)" @touchstart="e.tch = true") {{e.lbl}}


</template>

 <script>
import {fn_getCalendarData} from "@/utils/api.js";
import util, {fn_checkPageEnabled,kbdpAlert, kbdpRecord} from "@/utils/util.js";
import {refData, userInfo, fn_appEnt, userSettings} from "@/utils/ref-data.js";

const const_bkp = {};
export default {
	name: "kt-calendar",
	components: {},
	beforeCreate() {
		let kbdp = this.$parent;
		if (kbdp.d_cuFilter && kbdp.d_tmFilter) kbdp.d_tmFilter = null;
	},
	beforeDestroy() {
		let kbdp = this.$parent;
		if (!this.d_canVC && const_bkp.tm) {
			kbdp.d_tmFilter = const_bkp.tm;
		}
	},
	created() {
		this.d_canVC = userSettings.permissions.VTMC === true;

		let kbdp = this.$parent;
		if (!this.d_canVC && kbdp.d_tmFilter) {
			const_bkp.tm = kbdp.d_tmFilter;
			kbdp.d_tmFilter = null;
		}

		let t = new Date();
		let dt = this.d_today;
		let dp = this.d_period;

		dp.yr = dt.yr = t.getFullYear();
		dp.mnth = dt.mnth = t.getMonth();
		dt.day = t.getDate();
		dt.wkSt = fn_1stDOW().getTime();

		fn_setUserSetting(this);

		this.d_calItems.forEach(ci => {
			ci.recType = ci.key == 'ad' ? 'task' : /^(od|oa|os|swd|acsd|accd)$/.test(ci.key) ? 'oppr' : /^(pcsd|pccd)$/.test(ci.key) ? 'proj' : null;
		});
	},
	data() {
		return {
			d_canVC: null,
			d_today: {yr: null, mnth: null, day: null, wkSt: null},
			d_period: {yr: null, mnth: null, wkSt: null},
			d_cv: 'm', //Current View = (m)onth/(w)eek
			d_days: ['Sun', 'Mon', 'Tues', 'Wed', 'Thu', 'Fri', 'Sat'],
			d_calItems: [
				{key: 'ad', lbl: 'Activity Due', sel: true, },
				{key: 'od', lbl: 'Opportunity Due', sel: true, },
				{key: 'oa', lbl: 'Opportunity Awarded', sel: true, },
				{key: 'os', lbl: 'Opportunity Secured', sel: true, },
				{key: 'swd', lbl: 'Site Walk Through', sel: true, },
				{key: 'acsd', lbl: 'Approx Construction Start', sel: true, range: true},
				{key: 'accd', lbl: 'Approx Construction Completion', sel: true, range: true},
				{key: 'pcsd', lbl: 'Project Construction Start', sel: true, range: true},
				{key: 'pccd', lbl: 'Project Construction Completion', sel: true, range: true},
			],

			d_wksCache: [],//weeks in year cache
			d_calEventReqLog: [],//To keep track of periods already pulled from db

			d_refData: [],
			d_calDays: [], //Main calendar with dates and events

			d_daysInWeek: [],
			d_weeksInMonth: [],
		};
	},
	props: {
	},
	computed: {
		c_cuFilter() {
			return this.$parent.d_cuFilter;
		},
		c_tmFilter() {
			return this.$parent.d_tmFilter;
		},
		c_selWeeks() {
			let dp = this.d_period;
			let wc = this.d_wksCache;
			let wkSt = fn_1stDOW(new Date(dp.yr, 0, 1));

			let wks = (wc.filter(x => x.yr == dp.yr)[0] || {}).yrWks;
			if (wks) return wks;

			wks = [];
			while (wkSt.getFullYear() <= dp.yr) {
				wks.push({
					value: wkSt.getTime(),
					text: fn_fmtMMDDYYYY(wkSt) + ' - ' + fn_fmtMMDDYYYY(fn_dateadd(wkSt, 6))
				});
				wkSt = fn_dateadd(wkSt, 7);
			}
			// wks.forEach((x, ix) => {x.text = x.text + ' | ' + (ix + 1);});
			wc.push({yr: dp.yr, wks});
			return wks;
		},
		c_selMonths() {
			return refData.months.map((x, ix) => ({value: ix, text: x}));
		},
		c_selYears() {
			let yr = this.d_period.yr;
			let yrs = [];
			for (let i = yr - 5; i <= yr + 5; i++) {
				yrs.push({value: i, text: i});
			}
			return yrs;
		},
		c_isCurr() {
			let dp = this.d_period;
			let dt = this.d_today;
			switch (this.d_cv) {
				case 'w': return dp.wkSt == dt.wkSt;
				case 'm': return dp.yr == dt.yr && dp.mnth == dt.mnth;
				default: return null;
			}
		},
		c_YrMnth() {
			return this.d_period.yr + '-' + this.d_period.mnth;
		},
		c_cuTm() {
			return userInfo.getUserInfo().teamMember;
		},
		c_isTouch() {
			return this.$root.$children[0].d_isTouch;
		},
	},
	methods: {
		m_checkPage(page){return fn_checkPageEnabled(page);},
		m_prev() {
			let p = this.d_period;
			switch (this.d_cv) {
				case 'w': {
					let wkSt = new Date(p.wkSt);
					p.yr = wkSt.getFullYear() != p.yr ? p.yr - 1 : p.yr;
					p.wkSt = fn_dateadd(wkSt, -7).getTime();
					break;
				}
				case 'm': {
					p.yr = p.mnth == 0 ? p.yr - 1 : p.yr;
					p.mnth = p.mnth == 0 ? 11 : p.mnth - 1;
					break;
				}
			}
		},
		m_next() {
			let p = this.d_period;
			switch (this.d_cv) {
				case 'w': {
					let wkSt = new Date(p.wkSt);
					p.yr = wkSt.getFullYear() != p.yr ? p.yr + 1 : p.yr;
					p.wkSt = fn_dateadd(wkSt, 7).getTime();
					break;
				}
				case 'm': {
					p.yr = p.mnth == 11 ? p.yr + 1 : p.yr;
					p.mnth = p.mnth == 11 ? 0 : p.mnth + 1;
					break;
				}
			}
		},
		m_curr() {
			let dp = this.d_period;
			let dt = this.d_today;

			dp.yr = dt.yr;
			switch (this.d_cv) {
				case 'w': {dp.wkSt = dt.wkSt; break;}
				case 'm': {dp.mnth = dt.mnth; break;}
			}

		},
		m_refresh() {
			fn_getData(this, true, true);
		},

		m_toggleCalItem(ci) {
			ci.sel = !ci.sel;
			let val = this.d_calItems.filter(x => x.sel).map(x => x.key);
			util.fn_saveUserOpts('calendarEventsSelected', null, val);
		},

		m_popOvr(e) {
			return {
				trigger: 'hover',
				// trigger: 'click blur',
				placement: 'bottom',
				boundary: 'viewport',
				// delay: 300,
				delay: {"show": 300, "hide": 0},
				html: true,
				title: e.title,
				content: e.cntnt,
				container: '#kt-calendar',
				customClass: e.ci.key
			};
		},
		m_view(evnt, e) {
			e.preventDefault(); //Prevent "'Touch to Search' on chrome touch devices"
			// console.log(e.detail, e.type, evnt.tch)
			if (evnt.tch) {
				evnt.tch = null;
				if (e.detail == 1) {
					return;
				}
				else {
					setTimeout(() => {this.$root.$emit('bv::hide::popover');}, 301);
				}
			}

			let evd = evnt.evD;
			if (evd.prntType) {
				kbdpRecord.showTask(evd.prntType, evd.taskId, null, null, fn_tskSave);
			}
			else {
				if (evnt.rec) kbdpRecord.showRecord(evnt.rec.recType, evnt.rec.num);
			}
			let _this = this;
			function fn_tskSave(tskDta) {
				let refresh = evd.evDt != tskDta.dueDate || evd.taskName != tskDta.taskName;
				if (refresh) fn_getData(_this, false, true);
			}
		},
		m_addTask(day) {
			console.log('In m_addTask');
			let tm = this.c_tmFilter || this.c_cuTm || {};
			let tskDta = {
				dueDate: day ? util.fn_isoDtStr(day.dtLcl) : null,
				taskLeadId: tm.teamMemberId,
			};
			let refDta = {teamMemberId: [tm]};
			kbdpRecord.addTask('cal', tskDta, refDta, fn_tskSave);
			let _this = this;
			function fn_tskSave() {
				fn_getData(_this, false, true);
			}
		},
		m_addMeeting(day) {
			let tm = this.c_tmFilter || this.c_cuTm || {};
			let tskDta = {
				dueDate: day ? util.fn_isoDtStr(day.dtLcl) : null,
				taskLeadId: tm.teamMemberId,
			};
			let refDta = {teamMemberId: [tm]};
			kbdpRecord.addTask('cal', tskDta, refDta, fn_tskSave);
			let _this = this;
			function fn_tskSave() {
				fn_getData(_this, false, true);
			}
		},
	},
	watch: {
		d_cv(nv, ov) {
			let dp = this.d_period;
			if (nv == 'w') {
				let dt = this.d_today;
				let isCurrMnth = dp.yr == dt.yr && dp.mnth == dt.mnth; //Cant use c_isCurr here due to dependency/order?
				dp.wkSt = isCurrMnth ? dt.wkSt : fn_1stDOW(new Date(dp.yr, dp.mnth, 1)).getTime();
			}
			else if (nv == 'm') dp.mnth = fn_dateadd(dp.wkSt, 7).getMonth();
		},
		'd_period.yr'(nv, ov) {
			if (this.d_cv == 'w') {
				let dp = this.d_period;
				let dt = this.d_today;

				let skip = nv == dt.yr && dp.wkSt == dt.wkSt; //dt.wKSt already set by m_curr()
				if (!skip) dp.wkSt = fn_1stDOW(new Date(dp.yr, dp.mnth, 1)).getTime();
			}
		},

		c_YrMnth(nv) {
			if (this.d_cv == 'm') fn_setWeekInMonth(this);
			fn_getData(this);
		},
		'd_period.wkSt'() {
			fn_setDaysInWeek(this);
		},

		'$parent.c_cutmKey'(nv, ov) {
			fn_getData(this, false, true);
		},
	},

};

function fn_setUserSetting(vc) {
	let usrOpt = userSettings.userOptions.calendarEventsSelected;
	if (!usrOpt) return;

	vc.d_calItems.forEach(ci => {
		ci.sel = usrOpt.indexOf(ci.key) > -1;
	});
}

function fn_getData(vc, isRefresh, clear) {
	if (clear) {
		vc.d_calEventReqLog.length = 0;
		vc.d_calDays.filter(cd => cd.events).forEach(cd => cd.events = null);
	}
	let dp = vc.d_period;
	let YrMnth = vc.c_YrMnth;
	let d_cerl = vc.d_calEventReqLog;

	//check if need to make request
	var cerl = d_cerl.filter(x => x.YrMnth == YrMnth)[0];
	if (cerl && (Date.now() - cerl.reqDtm) / 1000 < 60) {return;}


	let reqPrms = {year: dp.yr, month: dp.mnth + 1};
	if (vc.c_cuFilter) reqPrms.currentUser = true;
	else if (vc.c_tmFilter) reqPrms.teamMemberId = vc.c_tmFilter.teamMemberId;
	if (isRefresh === true) reqPrms.refresh = true;

	// console.log('Getting Cal Data...', dp.yr, dp.mnth, new Date(dp.wkSt).toLocaleDateString());

	kbdpAlert.showLoading('Calendar Events', true);
	fn_getCalendarData(reqPrms).then(resp => {
		if (resp.error) {
			kbdpAlert.showErr(resp.error);
			return;
		}
		else {
			kbdpAlert.clear();
		}

		Object.keys(resp.refData).forEach(recType => {
			(resp.refData[recType] || []).forEach(recData => {
				let exists = vc.d_refData.filter(x => x.recType == recType && x.id == recData.id)[0];
				if (!exists) vc.d_refData.push(Object.assign(recData, {recType}));
			});
		});

		console.log('In fn_getCalendarData');
		console.log(resp);
		Object.keys(resp.evData).forEach(evKey => {

			let ci = vc.d_calItems.filter(x => x.key == evKey)[0];

			(resp.evData[evKey] || []).forEach(evData => {
				let evDt = new Date(evData.evDt + ':00:00');
				//let evDt = new Date(evData.evDt);
				let calDay = vc.d_calDays.filter(cd => cd.dtInt == evDt.getTime())[0];
				if (!calDay) {
					calDay = fn_calDay(evDt, vc);
					vc.d_calDays.push(calDay);
				}
				fn_calDayEvent(vc, calDay, ci, evData);
			});
		});


		//Add Log
		var cerl = d_cerl.filter(x => x.YrMnth == YrMnth)[0];
		let reqDtm = Date.now();
		if (cerl) cerl.reqDtm = reqDtm;
		else d_cerl.push({YrMnth, reqDtm});
	});
}



function fn_dateadd(date, days) {
	let d = new Date(date);
	d.setHours(0, 0, 0, 0);
	d.setDate(d.getDate() + days);
	return d;
}
function fn_1stDOW(date) {
	let d = date ? new Date(date) : new Date();
	d.setHours(0, 0, 0, 0);
	var fd = d.getDate() - d.getDay();

	return new Date(d.setDate(fd));
}
function fn_fmtMMDDYYYY(date) {
	let d = ('0' + date.getDate()).slice(-2);
	let m = ('0' + (date.getMonth() + 1)).slice(-2);
	let y = date.getFullYear();
	return `${m}/${d}/${y}`;
}

function fn_setDaysInWeek(vc) {
	let dp = vc.d_period;

	vc.d_daysInWeek = [];
	let day = new Date(dp.wkSt);

	for (let i = 1; i <= 7; i++) {
		let calDay = vc.d_calDays.filter(x => x.dtInt == day.getTime())[0];
		if (!calDay) {
			calDay = fn_calDay(day, vc);
			vc.d_calDays.push(calDay);
		}
		// calDay.class = [];
		if (day.getTime() == new Date().setHours(0, 0, 0, 0)) calDay.class = 'today';

		vc.d_daysInWeek.push(calDay);
		day = fn_dateadd(day, 1);
	}
}

function fn_setWeekInMonth(vc) {
	let dp = vc.d_period;

	let som = new Date(dp.yr, dp.mnth, 1); //Start of Month
	let eom = new Date(dp.yr, dp.mnth + 1, 0); //End of Month
	let soc = fn_dateadd(som, -som.getDay());//Start of Calendar
	let eoc = fn_dateadd(eom, (6 - eom.getDay())); //End of Calendar

	let monthCal = [];
	let day = soc;
	let calIx = 0;
	while (day <= eoc) {
		let calDay = vc.d_calDays.filter(x => x.dtInt == day.getTime())[0];
		if (!calDay) {
			calDay = fn_calDay(day, vc);
			vc.d_calDays.push(calDay);
		}

		calDay.wom = Math.floor(calIx / 7) + 1; //Used inside this function only.
		let cdc = calDay.class = [];
		if (day.getMonth() != som.getMonth()) cdc.push('not-curr');
		if (day.getTime() == new Date().setHours(0, 0, 0, 0)) cdc.push('today');

		if (!cdc.length) delete calDay.class;

		monthCal.push(calDay);
		day = fn_dateadd(day, 1);
		calIx++;
	}
	vc.d_weeksInMonth = [];
	let nod = som.getDay() + eom.getDate(); //# of days 
	let now = Math.ceil(nod / 7); //# of weeks 
	for (let i = 1; i <= now; i++) {
		vc.d_weeksInMonth.push({wom: i, days: monthCal.filter(x => x.wom == i)});
	}
}

function fn_calDay(day, vc) {
	// let events = {};
	// vc.d_calItems.forEach(ci => {events[ci.key] = null;});
	return {
		dtInt: day.getTime(),
		dtLcl: day.toLocaleDateString(),
		dom: day.getDate(),
		events: null,
		addbtn: false,
	};
}

function fn_calDayEvent(vc, calDay, ci, evD) {
	if (!calDay.events) calDay.events = [];

	let isad = ci.key == 'ad';
	let id = evD.taskId || evD.recId;
	let evId = `${ci.key}-${isad ? evD.prntType : '' + ci.recType}-${id}`;

	let cde = calDay.events.filter(x => x.evId == evId)[0];

	if (cde) return;


	let refDataKey = isad ? evD.prntType : ci.recType;
	let recId = isad ? evD.prntId : evD.recId;
	let rec = vc.d_refData.filter(x => x.recType == refDataKey && x.id == recId)[0] || {};

	// let ciL = ci.lbl.replace(' Dates', '').replace('ties ', 'y ');

	let event = {ci, evId, evD, rec};

	let aeNm = fn_appEnt(evD.prntType || ci.recType).Name;

	event.title = isad ? `${aeNm} ${ci.lbl}` : ci.lbl;
	event.lbl = isad ? evD.taskName : rec.name;
	// event.cntnt = util.fn_recLbl(rec.num, rec.name);
	event.cntnt = fn_cntnt();

	// event.href = util.fn_hrefVwRec(recType, rec.num);

	calDay.events.push(event);

	function fn_cntnt() {
		let isCalAd = evD.prntType == 'cal';
		let d = $('<div>', {});
		if (!isCalAd) {
			if (userSettings.userOptions.showRecordNumbers) {
				fn_divLblVal(d, aeNm + ' #', rec.num);
			}
			fn_divLblVal(d, aeNm + ' Name', rec.name);

		}

		if (isad) {
			fn_divLblVal(d, 'Activity Name', evD.taskName);
		}

		fn_divLblVal(d, ci.lbl.replace(aeNm, '') + ' Date', calDay.dtLcl);
		return d[0].innerHTML;


		function fn_divLblVal(tgt, lbl, val) {
			let lblVal = $('<div>').append($('<span>').append(lbl)).append($('<b>').append(val));
			tgt.append(lblVal);
		}
	}

}


</script>

<style scoped lang="less">
#kt-calendar {
	height: 100%;
	display: flex;
	flex-direction: column;

	> .kt-calendar-header {
		display: flex;
		flex-wrap: wrap;
		flex-grow: 0;

		border-bottom: solid 0.1em #adb5bd;
		padding-bottom: 0.2em;
		margin-bottom: 0.3em;

		> div.dropdown {
			margin: auto 0;
			button.dropdown-toggle {
				padding: 0em 0.3em;
				margin: auto 0;
			}

			ul.dropdown-menu {
				padding: 0.5em 0.2em;
			}
			// .dropdown-header {
			// }
			.dropdown-item {
				display: flex;
				border-bottom: solid 0.1em #dee2e6;
				cursor: pointer;

				padding: 0.1em 0.5em;
				span:first-child {
					margin-right: 0.5em;
					width: 0.5em;
					border-radius: 0.5em;
				}
				span:nth-child(2) {
					margin-right: 1em;
					font-size: 0.9em;
				}
				span:last-child {
					margin-left: auto;
					svg {
						&[data-icon="eye"] {
							color: #4fa4ff;
						}
						&[data-icon="eye-slash"] {
							opacity: 0.4;
						}
					}
				}
			}
		}
	}
	> .kt-calendar-content {
		// border: solid 0.1em red;
		flex-grow: 1;
		> div.header {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			padding: 0.2em 0;

			> div {
				padding: 0.2em 0;
				display: flex;

				> button {
					margin-right: 0.2em;
					padding: 0 0.4em;
					flex-wrap: nowrap;
					&.btn-prev,
					&.btn-next {
						&:hover {
							background-color: #dee2e6;
						}
					}
					&.btn-curr {
						font-size: 0.8em;
						margin: 0;
					}

					&.btn-add {
						font-size: 0.8em;
						padding: 0.1em 0.4em;
						line-height: 1.3em;
						margin-top: auto;
						margin-bottom: auto;
						border:none;
						background-color:rgba(79,164,255,.8);
						svg {
							margin-right: 0.2em;
						}
					}
					&.btn-refresh {
						margin-left: 0.2em;
						font-size: 0.9em;
					}
					&:hover{
						background-color: rgba(40, 167, 69, 0.12);
						}
				}
				> select {
					margin: 0 0.2em;
					font-size: 0.9em;
					&.sel-months {
						width: 100px;
					}
					&.sel-weeks {
						width: 200px;
					}
					&.sel-years {
						width: 75px;
					}
				}
			}
			> div:last-child {
				margin-left: auto;
			}
		}
		> div.content {
			overflow-x: auto;
			height: 100%;
			// -webkit-user-select: none;
			@media (max-width: 768px) {
				font-size: 0.9em;
			}
			> div {
				display: flex;
				flex-wrap: nowrap;
				width: 100%;
			}
			> div.days > div,
			> div.days-week > div,
			> div.week-month > div {
				min-width: 80px;
				flex-grow: 1;
				flex-basis: 0;
				flex-shrink: 0;
				direction: ltr;

				border: solid 0.1em #ced4da;
				border-top: none;
				&:not(:first-child) {
					border-left: none;
				}
			}
			div.days > div {
				font-size: 0.9em;
				background-color: #e9ecef;
				font-weight: bolder;
				// color: #fff;
			}
			div.days-week {
				height: calc(100% - 50px);
				> div {
					display: flex;
					flex-direction: column;
					padding: 0.5em 0;
				}
				> div span:first-child {
					font-size: 0.9em;

					padding: 0 0.5em;
					margin: 0em auto;
				}
				> div div.events {
					> div {
						font-size: 0.8em;
						padding: 0.2em 0.5em;
						margin: 0.4em 0;
					}
				}

				> div span.add {
					margin1: 0.5em auto;
					&::after {
						content: "Activity";
						font-size: 0.8em;
					}
				}
				> div span.meeting {
					margin11: 0.5em auto;
					&::after {
						content: "Meeting";
						font-size: 0.8em;
					}
				}
			}
			div.week-month > div {
				height: 120px;
				display: flex;
				flex-direction: column;

				&.not-curr {
					background-color: rgba(108, 117, 125, 0.05);
				}
				> span:first-child {
					line-height: 1em;
					width: 20px;
					margin: 0.2em 0.2em auto auto;
				}
				> div.events {
					> div {
						font-size: 0.8em;
						padding: 0 0.5em;
						margin: 0.2em 0;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}
				}

				> span.add {
					position: absolute;
					left: 0.2em;
					top: 0.2em;
					visibility: hidden;
					transition: visibility;

					&::after {
						content: "Activity";
						font-size: 0.8em;
					}
				}
				&:hover span.add {
					visibility: visible;
					transition-delay: 0.3s;
					background-color: rgba(40, 167, 69, 0.12);
				}
				> span.meeting {
					position: absolute;
					left: 0.2em;
					top: 1em;
					visibility: hidden;
					transition: visibility;

					&::after {
						content: "Meeting";
						font-size: 0.8em;
					}
				}
				&:hover span.meeting {
					visibility: visible;
					transition-delay: 0.3s;
					background-color: rgba(40, 167, 69, 0.12);
				}
				
			}

			div.days-week,
			div.week-month {
				> div {
					position: relative; //Needed for add button positioning
					&.today {
						> span:first-child {
							background-color: rgba(79, 164, 255, 0.8);
							color: #fff;
							font-size: 0.9em;
							border-radius: 1em;
							line-height: 1.5em;
						}
					}
				}
				div.events {
					width: 100%;
					overflow-y: auto;
					text-align: left;
					padding: 0 0.2em;
					> div {
						line-height: 1.3em;
						cursor: pointer;
						border: solid 0.1em #f8f9fa;
						border-radius: 0.25em;

						&:hover {
							border-color: #6c757d;
						}
					}
				}

				span.add {
					cursor: pointer;
					border-radius: 0.25em;
					line-height: 1em;
					padding1: 0 0.2em;
					opacity: 0.5;
					&::before {
						content: "+";
						padding-right: 0.1em;
					}
					&:hover {
						opacity: unset;
						background-color:#28a745;   //rgba(40, 167, 69, 0.12);
						//background-color: rgba(79, 164, 255, 0.3);
					}
				}
				span.meeting {
					cursor: pointer;
					border-radius: 0.25em;
					line-height: 1em;
					padding1: 0 0.2em;
					opacity: 0.5;
					&::before {
						content: "+";
						padding-right: 0.1em;
					}
					&:hover {
						opacity: unset;
						background-color: #28a745;  //rgba(40, 167, 69, 0.12);
						//background-color: rgba(79, 164, 255, 0.3);
					}
				}

			}
		}
	}

	> div.popover {
		// max-width: 400px;
		> .arrow ::after {
			border-bottom-color: #6c757d;
		}
		> .popover-header {
			padding: 0.1em 1em 0.1em 0.5em;
			// background-color: #6c757d;
			// color: #fff;
			font-weight: normal;
			font-size: 0.9em;
		}
		> .popover-body {
			padding: 0.25em 1em 0.5em 0.5em;
			// width: 300px;
			> div {
				font-size: 0.9em;
				> span::after {
					content: " :";
				}
				> b {
					display: block;
					padding-left: 0.5em;
					font-size: 0.95em;
				}
			}
		}
	}

	.kt-calendar-header div.dropdown div.dropdown-item > span:first-child,
	.kt-calendar-content div.days-week div.events > div,
	.kt-calendar-content div.week-month div.events > div {
		&.ad {
			background-color: rgba(79, 164, 255, 0.3);
		}
		&.od {
			background-color: rgba(40, 167, 69, 0.2);
		}
		&.oa {
			background-color: rgba(40, 167, 69, 1);
			color: #fff;
		}
		&.os {
			background-color: rgba(212, 84, 64, 0.6);
			color: #fff;
		}
		&.swd {
			background-color: rgba(111, 66, 193, 0.6);
			color: #fff;
		}
		&.acsd,
		&.accd {
			background-color: rgba(255, 193, 7, 0.8);
		}

		&.pcsd,
		&.pccd {
			background-color: rgba(3, 76, 93, 0.8);
			color: #fff;
		}
	}
}
.btn-wk,
.btn-mnth {
  font-size: 0.8em;
  color:white;
  transition: background-color 0.25s ease, color 0.25s ease;
}

/* Active + Hover share the same look */
.btn.active,
.btn-wk.active,
.btn-mnth.active,
.btn:hover,
.btn-wk:hover,
.btn-mnth:hover {
  color: white;
  background-color: #28a745;
}
</style>

